module.exports = __webpack_public_path__ + "static/media/smog.be409474.svg";